export const commonIcon = [
  "FCT01197",
  "FCT02773",
  "FCT01767",
  "FCT01205",
  "FCT03225",
];
export const iconSvg = {
  FCT01768: "airportpickup",
  FCT01269: "airportpickup",
  FCT01242: "airportpickup",
  FCT061447: "airportpickup",
  // =====================================================================
  FCT06805: "alarmclock",
  FCT07856: "alarmclock",

  // =====================================================================
  FCT0217: "baggagedeposit",
  FCT021419: "baggagedeposit",

  // =====================================================================
  FCT06889: "bathroom",
  FCT06159: "bathroom",
  FCT06835: "bathroom",
  FCT091118: "bathroom",
  FCT091119: "bathroom",

  // =====================================================================
  FCT01767: "car",
  FCT0114: "car",
  FCT01240: "car",
  FCT061510: "car",

  // =====================================================================
  FCT02779: "creditcard",
  // =====================================================================
  FCT04218: "drink",
  FCT041536: "drink",
  FCT041540: "drink",
  FCT05223: "drink",

  // =====================================================================
  FCT04160: "gymnasium",

  // =====================================================================
  FCT01197: "park",
  FCT01198: "park",
  FCT01196: "park",
  FCT011302: "park",
  FCT01195: "park",

  // =====================================================================
  FCT041534: "pool",
  FCT04268: "pool",
  FCT04163: "pool",
  FCT041533: "pool",
  FCT041129: "pool",
  FCT041514: "pool",
  FCT041128: "pool",
  FCT041538: "pool",
  FCT041516: "pool",
  FCT041541: "pool",

  // =====================================================================
  FCT02773: "reception",
  FCT02772: "reception",

  // =====================================================================
  FCT03225: "restaurants",
  FCT03226: "restaurants",
  FCT031311: "restaurants",
  FCT0312: "restaurants",
  FCT031102: "restaurants",
  FCT031103: "restaurants",
  FCT031420: "restaurants",
  FCT031531: "restaurants",

  // =====================================================================
  FCT061321: "phone",
  FCT061322: "phone",
  FCT07815: "phone",
  FCT07816: "phone",
  FCT07868: "phone",
  FCT07869: "phone",
  FCT07824: "phone",
  FCT07877: "phone",
  FCT07842: "phone",
  FCT07896: "phone",

  // =====================================================================
  FCT01205: "wifi",
  FCT01203: "wifi",
  FCT011418: "wifi",
  FCT011491: "wifi",
  FCT05202: "wifi",
  FCT06811: "wifi",
  FCT06204: "wifi",
  FCT06862: "wifi",
  FCT06864: "wifi",
  FCT07810: "wifi",
  FCT07809: "wifi",
  FCT07863: "wifi",

  // =====================================================================
  FCT011121: "general",
  FCT011120: "general",
  FCT01224: "general",
  FCT01213: "general",
  FCT01222: "general",
  FCT0215: "general",
  FCT021363: "general",
  FCT0210: "general",
  FCT0211: "general",
  FCT021064: "general",
  FCT02777: "general",
  FCT021448: "general",
  FCT021065: "general",
  FCT021492: "general",
  FCT02776: "general",
  FCT02210: "general",
  FCT0213: "general",
  FCT02775: "general",
  FCT0219: "general",
  FCT02771: "general",
  FCT021039: "general",
  FCT02807: "general",
  FCT02859: "general",
  FCT021038: "general",
  FCT02780: "general",
  FCT02238: "general",
  FCT0218: "general",
  FCT021364: "general",
  FCT02244: "general",
  FCT021359: "general",
  FCT021513: "general",
  FCT021365: "general",
  FCT03217: "general",
  FCT03236: "general",
  FCT041501: "general",
  FCT041045: "general",
  FCT04162: "general",
  FCT04220: "general",
  FCT04158: "general",
  FCT04211: "general",
  FCT041048: "general",
  FCT04245: "general",
  FCT04166: "general",
  FCT041367: "general",
  FCT04168: "general",
  FCT04167: "general",
  FCT04787: "general",
  FCT04178: "general",
  FCT04180: "general",
  FCT04161: "general",
  FCT041444: "general",
  FCT04174: "general",
  FCT04778: "general",
  FCT04165: "general",
  FCT04171: "general",
  FCT04173: "general",
  FCT0416: "general",
  FCT04169: "general",
  FCT04170: "general",
  FCT04870: "general",
  FCT04791: "general",
  FCT04789: "general",
  FCT04175: "general",
  FCT041046: "general",
  FCT04788: "general",
  FCT04251: "general",
  FCT04164: "general",
  FCT04176: "general",
  FCT041368: "general",
  FCT041518: "general",
  FCT041131: "general",
  FCT04177: "general",
  FCT041505: "general",
  FCT041522: "general",
  FCT041520: "general",
  FCT041130: "general",
  FCT041526: "general",
  FCT041507: "general",
  FCT041535: "general",
  FCT041519: "general",
  FCT041517: "general",
  FCT041347: "general",
  FCT041537: "general",
  FCT041524: "general",
  FCT04179: "general",
  FCT041523: "general",
  FCT041528: "general",
  FCT041530: "general",
  FCT041539: "general",
  FCT041508: "general",
  FCT041529: "general",
  FCT041494: "general",
  FCT041047: "general",
  FCT041043: "general",
  FCT05781: "general",
  FCT05820: "general",
  FCT05208: "general",
  FCT05782: "general",
  FCT05784: "general",
  FCT051041: "general",
  FCT05821: "general",
  FCT05874: "general",
  FCT05201: "general",
  FCT05200: "general",
  FCT05199: "general",
  FCT05215: "general",
  FCT051049: "general",
  FCT05206: "general",
  FCT05212: "general",
  FCT05214: "general",
  FCT05774: "general",
  FCT05227: "general",
  FCT05216: "general",
  FCT05221: "general",
  FCT05785: "general",
  FCT05786: "general",
  FCT051052: "general",
  FCT051053: "general",
  FCT051439: "general",
  FCT05207: "general",
  FCT051496: "general",
  FCT051431: "general",
  FCT05209: "general",
  FCT05237: "general",
  FCT051504: "general",
  FCT051503: "general",
  FCT061323: "general",
  FCT061325: "general",
  FCT061324: "general",
  FCT06239: "general",
  FCT061326: "general",
  FCT061502: "general",
  FCT061493: "general",
  FCT061512: "general",
  FCT061433: "general",
  FCT06219: "general",
  FCT06696: "general",
  FCT06738: "general",
  FCT061436: "general",
  FCT061366: "general",
  FCT061497: "general",
  FCT06247: "general",
  FCT061435: "general",
  FCT06799: "general",
  FCT061081: "general",
  FCT061122: "general",
  FCT06849: "general",
  FCT06246: "general",
  FCT061430: "general",
  FCT06812: "general",
  FCT061498: "general",
  FCT061446: "general",
  FCT061441: "general",
  FCT06797: "general",
  FCT06817: "general",
  FCT06212: "general",
  FCT06770: "general",
  FCT061437: "general",
  FCT06813: "general",
  FCT061362: "general",
  FCT061429: "general",
  FCT061062: "general",
  FCT061440: "general",
  FCT06872: "general",
  FCT06865: "general",
  FCT061069: "general",
  FCT061345: "general",
  FCT061068: "general",
  FCT061333: "general",
  FCT061499: "general",
  FCT06783: "general",
  FCT061500: "general",
  FCT061445: "general",
  FCT06769: "general",
  FCT061532: "general",
  FCT06243: "general",
  FCT061040: "general",
  FCT061126: "general",
  FCT061509: "general",
  FCT06822: "general",
  FCT061125: "general",
  FCT061099: "general",
  FCT06814: "general",
  FCT061127: "general",
  FCT06804: "general",
  FCT06885: "general",
  FCT061095: "general",
  FCT061037: "general",
  FCT061360: "general",
  FCT061056: "general",
  FCT061079: "general",
  FCT06892: "general",
  FCT061342: "general",
  FCT061057: "general",
  FCT061124: "general",
  FCT06866: "general",
  FCT061343: "general",
  FCT061098: "general",
  FCT061094: "general",
  FCT061073: "general",
  FCT061050: "general",
  FCT061111: "general",
  FCT061327: "general",
  FCT061087: "general",
  FCT061340: "general",
  FCT061089: "general",
  FCT06832: "general",
  FCT061449: "general",
  FCT06790: "general",
  FCT061086: "general",
  FCT061525: "general",
  FCT061076: "general",
  FCT061495: "general",
  FCT06875: "general",
  FCT061438: "general",
  FCT06867: "general",
  FCT061336: "general",
  FCT061088: "general",
  FCT061083: "general",
  FCT061313: "general",
  FCT061506: "general",
  FCT061058: "general",
  FCT061314: "general",
  FCT06861: "general",
  FCT061329: "general",
  FCT061090: "general",
  FCT061084: "general",
  FCT061341: "general",
  FCT061320: "general",
  FCT061331: "general",
  FCT06876: "general",
  FCT061042: "general",
  FCT061082: "general",
  FCT061319: "general",
  FCT061328: "general",
  FCT061527: "general",
  FCT061330: "general",
  FCT061093: "general",
  FCT061332: "general",
  FCT061339: "general",
  FCT06886: "general",
  FCT061315: "general",
  FCT061354: "general",
  FCT061055: "general",
  FCT061348: "general",
  FCT061317: "general",
  FCT061115: "general",
  FCT061353: "general",
  FCT061346: "general",
  FCT061369: "general",
  FCT061370: "general",
  FCT061344: "general",
  FCT061044: "general",
  FCT061357: "general",
  FCT07796: "general",
  FCT07808: "general",
  FCT07860: "general",
  FCT071350: "general",
  FCT07792: "general",
  FCT071309: "general",
  FCT07843: "general",
  FCT071318: "general",
  FCT07829: "general",
  FCT07882: "general",
  FCT07858: "general",
  FCT071074: "general",
  FCT071075: "general",
  FCT07826: "general",
  FCT071112: "general",
  FCT071070: "general",
  FCT07879: "general",
  FCT071113: "general",
  FCT071071: "general",
  FCT07841: "general",
  FCT07895: "general",
  FCT07820: "general",
  FCT07803: "general",
  FCT07834: "general",
  FCT07838: "general",
  FCT071427: "general",
  FCT071421: "general",
  FCT07794: "general",
  FCT07819: "general",
  FCT071308: "general",
  FCT07798: "general",
  FCT07818: "general",
  FCT071106: "general",
  FCT071104: "general",
  FCT07241: "general",
  FCT071422: "general",
  FCT07801: "general",
  FCT07806: "general",
  FCT07802: "general",
  FCT07827: "general",
  FCT071100: "general",
  FCT071066: "general",
  FCT07793: "general",
  FCT071434: "general",
  FCT071432: "general",
  FCT07828: "general",
  FCT071108: "general",
  FCT071063: "general",
  FCT071442: "general",
  FCT07852: "general",
  FCT071067: "general",
  FCT071123: "general",
  FCT07848: "general",
  FCT07890: "general",
  FCT07857: "general",
  FCT07851: "general",
  FCT07881: "general",
  FCT071443: "general",
  FCT071080: "general",
  FCT07853: "general",
  FCT07795: "general",
  FCT071105: "general",
  FCT07844: "general",
  FCT07880: "general",
  FCT071109: "general",
  FCT071310: "general",
  FCT07883: "general",
  FCT071107: "general",
  FCT07845: "general",
  FCT07800: "general",
  FCT07871: "general",
  FCT07850: "general",
  FCT071337: "general",
  FCT07873: "general",
  FCT07846: "general",
  FCT07847: "general",
  FCT07854: "general",
  FCT071051: "general",
  FCT071114: "general",
  FCT071101: "general",
  FCT071078: "general",
  FCT071054: "general",
  FCT071091: "general",
  FCT071072: "general",
  FCT071110: "general",
  FCT071085: "general",
  FCT071077: "general",
  FCT071060: "general",
  FCT071092: "general",
  FCT07823: "general",
  FCT071316: "general",
  FCT071361: "general",
  FCT071334: "general",
  FCT071355: "general",
  FCT071312: "general",
  FCT071335: "general",
  FCT071428: "general",
  FCT071358: "general",
  FCT072029: "general",
  FCT072035: "general",
  FCT072043: "general",
  FCT072126: "general",
  FCT08825: "general",
  FCT08878: "general",
  FCT081097: "general",
  FCT08739: "general",
  FCT081096: "general",
  FCT09894: "general",
  FCT09837: "general",
  FCT091338: "general",
  FCT09891: "general",
  FCT09884: "general",
  FCT09855: "general",
  FCT091351: "general",
};
